module.exports = __webpack_public_path__ + "img/basement.29b811bf.png";